module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_5_5_4.98423cea.jpeg";